document.addEventListener("DOMContentLoaded", () => {

  const gallery = document.querySelector("media-gallery");
  if (!gallery) return;

  const viewer = gallery.querySelector('[id^="GalleryViewer"]');
  const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');

  const prevArrow = thumbnails.querySelector('button[name="previous"]');
  const nextArrow = thumbnails.querySelector('button[name="next"]');

  if (!viewer || !prevArrow || !nextArrow) return;

  const getMediaItems = () => viewer.querySelectorAll('li[data-media-id]');

  function switchMedia(direction) {

    const mediaItems = Array.from(getMediaItems());
    const active = viewer.querySelector('.is-active');

    if (!active) return;

    const currentIndex = mediaItems.indexOf(active);

    let newIndex;

    if (direction === "next") {
      newIndex = currentIndex + 1 >= mediaItems.length ? 0 : currentIndex + 1;
    } else {
      newIndex = currentIndex - 1 < 0 ? mediaItems.length - 1 : currentIndex - 1;
    }
    console.log(mediaItems[1])
    console.log(mediaItems);
    const newMediaId = mediaItems[newIndex].dataset.mediaId;

    gallery.setActiveMedia(newMediaId);
  }

  prevArrow.addEventListener("click", (e) => {
    e.preventDefault();
    switchMedia("prev");
  });

  nextArrow.addEventListener("click", (e) => {
    e.preventDefault();
    switchMedia("next");
  });

});